import useProtectedMutation from './use-protected-mutation';

import RebatesClient from '../RebatesClient';

/**
 * Fetches a single saved statement (with its lines) on demand via
 * GET /api/report/statements/:id. Used to regenerate the PDF for download.
 *
 * The mutation result is the full statement: { ...header, lines: [...] }.
 */
export default function useDownloadStatement() {
  return useProtectedMutation({
    mutationKey: ['download_statement'],
    mutationFn: async (statementId) => {
      const result = await RebatesClient.getStatement(statementId);

      if (!result.response.ok) {
        throw new Error(result.body?.status || 'Error getting statement');
      }

      return result.body?.statement || null;
    }
  });
}
